// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  // reqBaseUrl: 'http://localhost:8000/api/v1/',
  // imgBaseUrl: 'http://localhost:8000/',
  // socketUrl: 'http://localhost:8000/',
  uploadFileSize: 5000000,
  // dropBoxToken:
  //   '3FXO3l84gTkAAAAAAAAAAVKAMVrlM6D095PZU3jMQYbMJsTtK2icKryruFLyJfUT',
  dropBoxToken:
    'sl.BmywkQLG3LiOxN0pqUO59OrTrsTSUz35y6qFEn-3gHL_RFsnWaY37q0uLyDBemEtSEgiFICeqD8-3WIBm4ElFAXUB10PDUPnlzdtPR2x-8OlqcJ2hyG_DoRkFq7MZKr2Lzbtl4PgREsw',
  reqBaseUrl: 'https://back.fhshah.com:8813/api/v1/',
  imgBaseUrl: 'https://back.fhshah.com:8813/',
  socketUrl: 'https://back.fhshah.com:8813/',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
import 'zone.js/plugins/zone-error'; // Included with Angular CLI.
